import { useContext } from 'react';
import { PriceContext } from './priceProvider';

type FormatOptions = {
  isNegative?: boolean,
  isPositive?: boolean,
};

export const usePriceFormat = () => {
  const { locale, showCurrencySign, currency } = useContext(PriceContext);
  const format = showCurrencySign
      ? { style: 'currency', currency }
      : { minimumFractionDigits: 2 };

  return (value: number, options?: FormatOptions) => {
    const result = new Intl.NumberFormat(locale || 'en-GB', format as Intl.NumberFormatOptions).format(value);
    let prefix = '';
    if (options?.isNegative) prefix = '-';
    if (options?.isPositive) prefix = '+';
    return [prefix, result].filter(Boolean).join(' ');
  };
};
